var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "89694E08-DE82-45EA-A109-905A0504675B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBlue---Milestone-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "12.0_Creatives_01",
    transform: "translate(-314.000000, -502.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(260.000000, 425.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-copy",
    transform: "translate(0.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02.Icons-/-Basic-/-Solid-/-Bath-Tub",
    transform: "translate(54.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,0.833333333 C10.23716,0.833333333 10.4292933,1.02561333 10.4292933,1.26262667 L10.4292933,1.26262667 L10.4292933,1.56652 L18.7285733,1.56652 C18.9657333,1.56652 19.1580133,1.7588 19.1580133,1.99566667 C19.1580133,2.23268 18.9657333,2.42496 18.7285733,2.42496 L18.7285733,2.42496 L18.7285733,3.28545333 C18.7285733,3.52246667 18.52852,3.71284 18.2915067,3.71284 L18.2915067,3.71284 L18.2994267,3.71284 L18.2994267,14.57468 C18.2994267,14.81184 18.00272,15.0171733 17.76556,15.0171733 L17.76556,15.0171733 L10.4292933,15.0171733 L10.4292933,18.3082267 L14.1502267,18.3082267 C14.3873867,18.3082267 14.57952,18.5005067 14.57952,18.73752 C14.57952,18.9745333 14.3873867,19.1668133 14.1502267,19.1668133 L14.1502267,19.1668133 L5.85094667,19.1668133 C5.61378667,19.1668133 5.42165333,18.9745333 5.42165333,18.73752 C5.42165333,18.5005067 5.61378667,18.3082267 5.85094667,18.3082267 L5.85094667,18.3082267 L9.57085333,18.3082267 L9.57085333,15.0171733 L2.23561333,15.0171733 C1.99845333,15.0171733 1.84386667,14.8116933 1.84386667,14.57468 L1.84386667,14.57468 L1.84386667,3.71284 L1.70966667,3.71284 C1.47250667,3.71284 1.27142667,3.52246667 1.27142667,3.28545333 L1.27142667,3.28545333 L1.27142667,2.42496 C1.03426667,2.42496 0.842133333,2.23268 0.842133333,1.99566667 C0.842133333,1.7588 1.03426667,1.56637333 1.27142667,1.56637333 L1.27142667,1.56637333 L9.57070667,1.56637333 L9.57070667,1.26262667 C9.57070667,1.02561333 9.76284,0.833333333 10,0.833333333 Z M9.99134667,4.7024 C7.78166667,4.7024 5.99042667,6.49393333 5.99042667,8.70332 C5.99042667,10.9131467 7.78166667,12.7045333 9.99134667,12.7045333 C12.2010267,12.7045333 13.9924133,10.9131467 13.9924133,8.70332 C13.9924133,6.49393333 12.2010267,4.7024 9.99134667,4.7024 Z M9.11589333,6.69457333 C9.22032,6.69457333 9.33134667,6.73124 9.44252,6.8034 L9.44252,6.8034 L11.60116,8.25510667 C11.7734933,8.36745333 11.8727867,8.53142667 11.8727867,8.70361333 C11.8727867,8.8758 11.7729067,9.03992 11.5986667,9.15329333 L11.5986667,9.15329333 L9.44310667,10.6022133 C9.33032,10.67584 9.22002667,10.7125067 9.1156,10.7125067 C8.91569333,10.7125067 8.71212,10.56276 8.71212,10.22836 L8.71212,10.22836 L8.71212,7.17857333 C8.71212,6.84432 8.91584,6.69457333 9.11589333,6.69457333 Z",
    id: "Combined-Shape",
    fill: "currentColor"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdVideoIcon);
export default __webpack_public_path__ + "static/media/AdVideoIcon.db622f8138f1f3cd957420034ab46f0b.svg";
export { ForwardRef as ReactComponent };